const courseRouter = [
	{
		// 新版H5课程首页 （将来删除团购 offline column 全部综合到这个里面统一处理）
		path: '/course',
		name: 'course-home',
		component: _ => import("@/pages/course/index.vue"),
		meta: {
			title: '课程简介'
		},
	},
	{
		path: '/column-course',
		name: 'column-course',
		component: _ => import("@/pages/course/index.vue"),
		meta: {
			title: '专栏课程'
		},
	},
	{
		path: '/offline-course',
		name: 'offline-course',
		meta: {
			title: '课程'
		},
		redirect: to => {
			return { path: '/course', query: to.query }
		},
	},
	{
		path: "/groupBuying",
		name: 'groupBuying',
		meta: {
			// 页面标题title
			title: 'CEO的新商业学堂'
		},
		redirect: to => {
			return { path: '/course', query: to.query }
		},
	},
	{
		path: '/special-column',
		name: 'special-column',
		meta: {
			title: '专栏'
		},
		redirect: to => {
			return { path: '/course', query: to.query }
		},
	},
	{
		path: '/user-list',
		name: 'user-list',
		component: _ => import("@/pages/course/user-list.vue"),
		meta: {
			title: '最近参与用户'
		}
	},
	{
		path: '/course-study',
		name: 'course-study',
		component: _ => import("@/pages/course/study.vue"),
		meta: {
			title: '学习页'
		}
	},
	{
		path: '/search',
		name: 'search',
		component: _ => import("@/pages/search/index.vue"),
		meta: {
			title: '搜索'
		}
	},
	{
		path: '/payment',
		name: 'payment',
		component: _ => import("@/pages/payment/index.vue"),
		meta: {
			title: '下单'
		}
	},
	{
		path: '/order-info',
		name: 'order-info',
		component: _ => import('@/pages/payment/order-info.vue'),
		meta: {
			title: '预报名成功'
		},
	}
]
export default courseRouter;
